import type { FC } from 'react'

interface AssignAuthorizeProps {
  currentUser: any
}

const AssignAuthorize: FC<AssignAuthorizeProps> = ({ currentUser }) => {
  return (
    <div className='rounded border border-dashed border-gray-300 bg-gray-50 p-6 text-center text-sm text-gray-500'>
      Assign Authorize placeholder for {currentUser?.name ?? 'user'}
    </div>
  )
}

export default AssignAuthorize

